import { Pipe, PipeTransform } from '@angular/core';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { CommonService } from '../services/common.service';

@Pipe({ name: 'decimalFormatter' })

export class DecimalFormatterPipe implements PipeTransform {
    constructor(private apiserviceProvider: APIServiceProviderService, public commonService : CommonService) {

    }
    transform(str: any, args: any): any {
        const visibleDigitLength = CommonService.decimalvisibleLength?.toString() ? 
        CommonService.decimalvisibleLength : 4;
        let number = str;
        if ((str != null && str !== '' && str != undefined && this.commonService.isFocusOut && /^[a-z_A-Z]+$/.test(str) != true)) {
            number = Number(str.toString().replace(/,/g,'')).toFixed(visibleDigitLength).toString();
        }
        return isNaN(number) ? str : number;
    }
}
